import * as React from 'react';
import {useDispatch} from 'react-redux';

import {colors} from 'shells/colors/colors';
import {WarningSolidIcon} from 'shells/icon/svg/warning-solid-icon';

import {openAllLimitsModal} from './limits-actions';

import styles from './title-bar-limits.module.css';

export function LimitsWarning() {
    const dispatch = useDispatch();

    const openModal = () => {
        dispatch(openAllLimitsModal({}));
    };

    return (
        <div
            onClick={openModal}
            data-tip='Your usage is above some plans’ limits'
            className={styles['title-bar-warning']}
        >
            <WarningSolidIcon size={15} color={colors.yellow} />
        </div>
    );
}
